import React from 'react'

export const DrawerStyles: { [key: string]: React.CSSProperties } = {
    container: { marginBottom: 13 },
    drawer: {
        width: 300,
        zIndex: 900,
        height: '100%',
        overflow: 'auto',
        backgroundColor: '#fff',
        boxShadow: '5px 0px 4px 0px #0000001A',
    },
    drawerHeader: {
        paddingTop: 20,
        paddingLeft: 10,
        paddingRight: 10,
        paddingBottom: 20,
        backgroundColor: '#2699D6',
    },
    drawerHeaderTop: {
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
    },
    drawerHeaderBtn: {
        paddingTop: 7,
        paddingLeft: 4,
        paddingRight: 6,
        borderRadius: 6,
        paddingBottom: 4,
        cursor: 'pointer',
        backgroundColor: '#FFF',
    },
    drawerContent: {
        paddingTop: 20,
        paddingLeft: 12,
        paddingRight: 12,
        paddingBottom: 20,
        position: 'relative',
    },
    sectionItem: {
        width: '100%',
        paddingTop: 15,
        paddingLeft: 10,
        borderRadius: 6,
        marginBottom: 5,
        paddingRight: 10,
        cursor: 'pointer',
        paddingBottom: 15,
        backgroundColor: '#f6f7fa',
    },
    sectionItemBtn: {
        width: '100%',
        paddingTop: 10,
        display: 'flex',
        paddingRight: 17,
        cursor: 'pointer',
        paddingBottom: 10,
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'transparent',
    },
    sectionItemBtnContent: {
        flex: 1,
        display: 'flex',
        paddingRight: 5,
        alignItems: 'center',
        justifyContent: 'flex-start',
    },
    storeBtn: {
        width: '100%',
        paddingTop: 10,
        display: 'flex',
        borderRadius: 6,
        paddingLeft: 10,
        paddingRight: 10,
        marginBottom: 15,
        paddingBottom: 10,
        marginLeft: 'auto',
        marginRight: 'auto',
        cursor: 'pointer',
        alignItems: 'center',
        justifyContent: 'center',
        border: '1.5px solid #2699D6',
        backgroundColor: 'white',
    },
    changeBtnStyle: {
        display: 'flex',
        height: 22,
        width: 24,
    },
    homeBtn: {
        width: '100%',
        paddingTop: 10,
        display: 'flex',
        borderRadius: 6,
        paddingLeft: 10,
        paddingRight: 10,
        marginBottom: 15,
        paddingBottom: 10,
        cursor: 'pointer',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f6f7fa',
    },
    homeBtnContent: {
        flex: 1,
        display: 'flex',
        paddingRight: 5,
        alignItems: 'center',
        justifyContent: 'flex-start',
    },
    payBtn: {
        width: '100%',
        paddingTop: 14,
        borderRadius: 6,
        marginBottom: 15,
        cursor: 'pointer',
        paddingBottom: 14,
        backgroundColor: '#74BE00',
    },
    suscriptionContainer: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    suscriptionBtn: {
        paddingTop: 7,
        display: 'flex',
        borderRadius: 6,
        marginBottom: 7,
        paddingLeft: 20,
        paddingRight: 20,
        cursor: 'pointer',
        paddingBottom: 10,
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#fff',
        border: '1px solid #0086D6',
    },
}
